import { render, staticRenderFns } from "./ComposerPage.vue?vue&type=template&id=a7d46f4e&scoped=true"
import script from "./ComposerPage.vue?vue&type=script&lang=js"
export * from "./ComposerPage.vue?vue&type=script&lang=js"
import style0 from "./ComposerPage.vue?vue&type=style&index=0&id=a7d46f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d46f4e",
  null
  
)

export default component.exports